import { gql } from '@apollo/client';
import { apolloClient } from 'Components/Root';

const GET_REDIRECT_HOST = gql`
  query GetRedirectHost($url: String!) {
    getRedirectHost(url: $url) {
      hostname
    }
  }
`;

export const REDIRECT_URL_NOT_ALLOWED_MESSAGE =
  'The Redirect URL you presented is not valid or has not been registered as a valid redirect URL.';

// True only when the URL's host is in the business's Allowed Redirect Domains
// (admin > Storefront > WordPress settings). Anything else — unparsable URL,
// non-http(s) scheme, unregistered host, network error — is not a redirect target.
export const isAllowedRedirectUrl = async (url) => {
  if (typeof url !== 'string' || !url) return false;

  try {
    const { data } = await apolloClient.query({
      query: GET_REDIRECT_HOST,
      variables: { url },
      fetchPolicy: 'network-only',
    });

    return !!data?.getRedirectHost?.hostname;
  } catch (error) {
    return false;
  }
};
